import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=1aa4eb64&scoped=true&"
import script from "./nodata.vue?vue&type=script&lang=js&"
export * from "./nodata.vue?vue&type=script&lang=js&"
import style0 from "./nodata.vue?vue&type=style&index=0&id=1aa4eb64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4eb64",
  null
  
)

export default component.exports